






import about from "../../../assets/imageforabout/illustration.jpg"
import React, { useEffect , useState } from 'react';
import EnquiryDialog from "../../dialog";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
export const Contactcomp = (props) => {

  useEffect(() => {
    AOS.init({
      duration: 1000, 
     
    });
  }, []);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleEnquirySubmit = (formData) => {
    console.log("Submitted:", formData);
    // Add your form submission logic here
  };

  return (
    <div id='about123'>
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-md-12'  >
            {' '}
           
          </div>  <h2  >Ready to Experience the RedRuby Difference?
</h2>
          
          



          
              <p  > <strong> Let us take care of your IT infrastructure, so you can focus on achieving your business goals </strong> <br/> Contact RedRuby Technologies today for a free consultation to discuss your specific IT needs.
We'll be your trusted partner in building a secure, reliable, and efficient IT foundation for your business success! </p>
           
 
<div style={{marginBottom:20  , display:"flex"   , justifyContent:"center", alignItems:"center"}} className="px-5 py-4 pb-5">
                <a href="/careers" > <button  type="submit" style={{ fontWeight:"bold" }} data-mdb-button-init data-mdb-ripple-init  className='btn btn-custom btn-lg page-scroll' data-aos='fade-up'>Get In Touch With Us</button> </a>    
                  </div>
             
        </div>
      </div>
      <EnquiryDialog isOpen={isDialogOpen} onClose={handleDialogClose} onSubmit={handleEnquirySubmit} />
    </div>
  )
}
